import dayjs from "~/utils/dayjs";

/**
 * Calendar bounds for the MUI-era `disablePast` / `disableFuture` flags,
 * which Mantine's pickers express as `minDate` / `maxDate`.
 */
export const getDateLimits = ({
  disableFuture,
  disablePast,
}: {
  disableFuture?: boolean;
  disablePast?: boolean;
}): { maxDate?: Date; minDate?: Date } => ({
  maxDate: disableFuture ? dayjs().endOf("day").toDate() : undefined,
  minDate: disablePast ? dayjs().startOf("day").toDate() : undefined,
});

export const earliest = (a?: Date, b?: Date): Date | undefined =>
  a && b ? (a < b ? a : b) : (a ?? b);

export const latest = (a?: Date, b?: Date): Date | undefined =>
  a && b ? (a > b ? a : b) : (a ?? b);
